
import NLoadingCircle from '@/uikit/loading/NLoadingCircle.vue';
import { Options, Vue } from 'vue-property-decorator';

@Options({
  components: { NLoadingCircle }
})
export default class VideoWallPlayerLoader extends Vue {}
